import { mapGetters } from "vuex";
import countries from "@/assets/js/countryList";
import { stripe_key } from '@/assets/js/utils'
import { eventBus } from "@/main";

const style = {
  base: {
    color: '#32325d',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#88A4CF'
    }
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a'
  }
};

const stripe = window.Stripe(stripe_key());
export default {

  data() {
    return {
      loader: false,
      dialog: false,
      cardElement: null,
      client_secret: null,
      cardDetail: {
        name: '',
        streetAddress: '',
        phone: '',
        country: '',
        teamMemberQuantity: 0,
        stripe_plan: 'monthly',
        stripe_product: 'professional',
      },
      product: null,
      countries: countries,


    }
  },
  computed: {
    ...mapGetters(["getSelectedCompany", "getCompanyCards"])
  },
  mounted() {
    this.cardElement = stripe.elements().create('card', { style });
    this.paymentIntent();
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.cardDetail = {
        name: '',
        streetAddress: '',
        phone: '',
        country: '',
        teamMemberQuantity: 0,
        stripe_plan: 'monthly'
      };
      this.cardElement = stripe.elements().create('card', { style });
      this.option = {
        plan: null,
        product: null,
        amount: 0,
      };
    },
    paymentIntent() {

      let data = {
        company_id: this.getSelectedCompany.id,
      };
      this.$store.dispatch("stripePayment", data).then((response) => {
        this.client_secret = response.data.intent.client_secret;
      });
    },



    stripeInvoiceListing() {

      let data = {
        company_id: this.getSelectedCompany.id,
      };
      this.$store.dispatch("stripeInvoiceListing", data).then((response) => {
      });
    },
    cardListing() {
      let data = {
        company_id: this.getSelectedCompany.id,
      };
      this.$store.dispatch("cardListing", data).then((response) => { });
    },
    submit() {
      this.pay();
    },
    async pay() {
      this.loader = true;
      const { setupIntent, error } = await stripe.handleCardSetup(
        this.client_secret, this.cardElement, {
        payment_method_data: {
          billing_details: {
            name: this.cardDetail.name,
            phone: this.cardDetail.phone,
            address: {
              country: this.cardDetail.country,
              line1: this.cardDetail.streetAddress
            }
          }
        }
      }
      );
      if (error) {
        this.openSnackbar(true, error.message);
        this.loader = false;
        this.$forceUpdate();
        this.paymentIntent();
      }
      else {
        let cardDetails = {
          company_id: this.getSelectedCompany.id,
          stripe_info: JSON.stringify(setupIntent),
          stripe_token: setupIntent.payment_method,
          plan: this.cardDetail.stripe_product + "_" + this.cardDetail.stripe_plan,
          default: this.getSelectedCompany.subscribed_plan && ( this.getSelectedCompany.subscribed_plan.toLowerCase() == "basic" || this.getSelectedCompany.subscribed_plan.toLowerCase()=="unlimited_plan") ? 1 : 0
        };
        if (this.getSelectedCompany.subscribed_plan && ( this.getSelectedCompany.subscribed_plan.toLowerCase() == "basic" || this.getSelectedCompany.subscribed_plan.toLowerCase()=="unlimited_plan")) {
          cardDetails["quantity"] = this.cardDetail.teamMemberQuantity;
        }
        else{
          cardDetails["add_card"] = true ;
        }
        this.stripeAddClient(cardDetails);

      }
    },
    stripeAddClient(cardDetails) {
      this.$store.dispatch("stripeAddClient", cardDetails).then((response) => {
        this.loader = false;
        this.openSnackbar(false, response.data.message);
        this.closeDialog();
        this.cardListing();
        this.stripeInvoiceListing();
        this.$store.dispatch("fetchAllCompaniesList").then((response) => {
          if (response.status == 200) {
            eventBus.$emit("switchTab", "gateway-tab")
          }
        });
      })
        .catch((error) => {
          this.loader = false;
          this.openSnackbar(true, error.response.data.message);
          this.paymentIntent();
        });


    },
  }
}
